import React from "react";
import { connect } from "react-redux";
import "./canvassolostartoverlay.style.scss";
const CANVAS_SOLO_START_OVERLAY_CLASS = "canvas-solo-start-overlay";

type Props = {
  canvasHeight: number;
  soloStartOverlayText: string;
};

const CanvasSoloStartOverlay = ({ canvasHeight, soloStartOverlayText }: Props) => {
  return (
    <span
      className={CANVAS_SOLO_START_OVERLAY_CLASS}
      style={{
        width: "85%",
        top: `${canvasHeight / 2 - 40}px`,
        fontSize: "24px"
      }}
    >
      <span>{soloStartOverlayText}</span>
    </span>
  );
};

const mapStateToProps = (state) => {
  const { canvasHeight } = state;
  return {
    canvasHeight,
  };
};

export default connect(mapStateToProps, {})(CanvasSoloStartOverlay);
